import {observable} from 'mobx';
import {t} from 'shared/core';
import {SurveyQuestionOption} from 'stores/surveys';

class SentimentFormState {
  @observable question;

  load() {
    if(this.question.sortedSentimentOptions.length === 0) {
      this.question.sentimentOptions = ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree'].map((num, index) =>
        new SurveyQuestionOption({
          title: t(`components.question_form.sentiment.${num}`),
          order: index
        })
      );
    }
  }

  receiveProps({question}) {
    this.question = question;
  }
}

export default SentimentFormState;
